var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Stock } from './Model';
export default class default_1 {
    constructor() {
        this.stock = [];
        this.set = (stock) => {
            this.stock = stock.map(customer => new Stock(customer));
        };
    }
    read(article) {
        if (article)
            return api
                .get(`stock?article=${article}`)
                .then(stock => stock.map(s => new Stock(s)));
        return api.get('stock').then(this.set);
    }
    create(inventory) {
        return api
            .post('inventory', inventory)
            .then(() => this.read(inventory.article));
    }
}
__decorate([
    observable
], default_1.prototype, "stock", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stock/Store.ts
// module id = 338
// module chunks = 0